import {
	AfterViewInit,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { faSortDown } from '@fortawesome/free-solid-svg-icons';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { spreadsheetInterface } from 'src/app/util/interfaces/spreadsheet';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ReportSpreadsheetService } from './service/report-spreadsheet.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'pcp-report-spreadsheet',
	templateUrl: './report-spreadsheet.component.html',
	styleUrls: ['./report-spreadsheet.component.scss'],
})
export class ReportSpreadsheetComponent implements OnInit, AfterViewInit, OnChanges {
	faSortDown = faSortDown;

	@Input()
	spreadsheetData: spreadsheetInterface;

	@Input()
	exportExcelInput: boolean;

	@Input()
	idIndicator: string;

	labels: LabelsInterface = {
		lbl_edocs_carregando: 'Loading',
	};

	isLoadingSpreadsheet = true;
	isLoadingLabels = true;

	constructor(
		private ReportSpreadsheetService: ReportSpreadsheetService,
		private ExcelService: ExcelService,
		private LabelsService: LabelsService
	) {}

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		if (!this.spreadsheetData && !this.idIndicator) {
			throw 'neither spreadsheet neither indicador id is defined to initialize component';
		} else if (this.idIndicator) {
			this.ReportSpreadsheetService.getSpreadsheetData(this.idIndicator).subscribe(
				(spreadsheet) => {
					this.spreadsheetData = this.fulfillSpreadsheet(spreadsheet);
					this.sortSpreadsheet();
					this.isLoadingSpreadsheet = false;
				},
				(error) => {}
			);
		} else {
			this.spreadsheetData = this.fulfillSpreadsheet(this.spreadsheetData);
			this.sortSpreadsheet();
			this.isLoadingSpreadsheet = false;
		}
	}

	ngAfterViewInit(): void {}

	ngOnChanges(change: SimpleChanges): void {
		if (change && change.exportExcelInput && change.exportExcelInput.currentValue === true) {
			this.exportExcel();
		}
	}

	@HostListener('window:keydown', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (
			this.spreadsheetData &&
			this.spreadsheetData.selectedItemAxis &&
			this.spreadsheetData.selectedItemAxis[0] !== -1 &&
			this.spreadsheetData.selectedItemAxis[1] !== -1
		) {
			const keyMoves = {
				ArrowUp: () => {
					if (this.spreadsheetData.selectedItemAxis[1] > 1) {
						this.spreadsheetData.selectedItemAxis[1] = this.spreadsheetData.selectedItemAxis[1] - 1;
					}
				},
				ArrowRight: () => {
					if (
						this.spreadsheetData.selectedItemAxis[0] <
						this.spreadsheetData.lines[this.spreadsheetData.selectedItemAxis[1]].cells.length - 1
					) {
						this.spreadsheetData.selectedItemAxis[0] = this.spreadsheetData.selectedItemAxis[0] + 1;
					}
				},
				ArrowDown: () => {
					if (this.spreadsheetData.selectedItemAxis[1] < this.spreadsheetData.lines.length - 1) {
						this.spreadsheetData.selectedItemAxis[1] = this.spreadsheetData.selectedItemAxis[1] + 1;
					}
				},
				ArrowLeft: () => {
					if (this.spreadsheetData.selectedItemAxis[0] > 0) {
						this.spreadsheetData.selectedItemAxis[0] = this.spreadsheetData.selectedItemAxis[0] - 1;
					}
				},
			};

			if (keyMoves[event.key]) {
				keyMoves[event.key]();
			}
		}
	}

	fulfillSpreadsheet(spreadsheet: spreadsheetInterface): spreadsheetInterface {
		if (!spreadsheet.lines) {
			spreadsheet.lines = [];
		}

		for (let index = spreadsheet.lines.length; index < 12; index++) {
			spreadsheet.lines.push({ generatedBlank: true, cells: [] });
		}

		let spreadSheetWidth = 6;
		for (let index = 0; index < spreadsheet.lines.length; index++) {
			if (spreadsheet.lines[index].cells.length > spreadSheetWidth) {
				spreadSheetWidth = spreadsheet.lines[index].cells.length;
			}
		}

		for (let index = 0; index < spreadsheet.lines.length; index++) {
			for (let index_ = spreadsheet.lines[index].cells.length; index_ < spreadSheetWidth; index_++) {
				spreadsheet.lines[index].cells.push({ item_name: '', item_value: '' });
			}
		}
		return spreadsheet;
	}

	cleanBlanks(spreadsheet: spreadsheetInterface): spreadsheetInterface {
		for (let index = 0; index < spreadsheet.lines.length; index++) {
			if (spreadsheet.lines[index].generatedBlank === true) {
				spreadsheet.lines.splice(index, 1);
				index--;
			}
		}

		return spreadsheet;
	}

	/*drag stuff*/
	@ViewChild('spreadsheetContainer')
	spreadsheetEl: ElementRef<HTMLElement>;
	spreadsheetPos = { top: 0, left: 0, x: 0, y: 0, mouseDown: false, mouseMove: false };
	impactMapMouseDown = (e: MouseEvent) => {
		this.spreadsheetPos.left = this.spreadsheetEl.nativeElement.scrollLeft;
		this.spreadsheetPos.top = this.spreadsheetEl.nativeElement.scrollTop;
		this.spreadsheetPos.x = e.clientX;
		this.spreadsheetPos.y = e.clientY;
		this.spreadsheetPos.mouseDown = true;
	};

	confirmMouseMove = () => {
		if (this.spreadsheetPos.mouseDown === true) this.spreadsheetPos.mouseMove = true;
	};

	impactMapMouseMove = (event: MouseEvent) => {
		// How far the mouse has been moved
		const dx = event.clientX - this.spreadsheetPos.x;
		const dy = event.clientY - this.spreadsheetPos.y;

		// Scroll the element
		this.spreadsheetEl.nativeElement.scrollTop = this.spreadsheetPos.top - dy;
		this.spreadsheetEl.nativeElement.scrollLeft = this.spreadsheetPos.left - dx;
	};

	impactMapMouseUp = () => {
		this.spreadsheetPos.mouseDown = false;
		this.spreadsheetPos.mouseMove = false;
	};
	/*End of drag stuff*/

	handleSelectedSpreadsheetItem(x: number, y: number): void {
		if (this.spreadsheetData.selectedItemAxis[0] === x && this.spreadsheetData.selectedItemAxis[1] === y) {
			this.spreadsheetData.selectedItemAxis[0] = -1;
			this.spreadsheetData.selectedItemAxis[1] = -1;
		} else {
			this.spreadsheetData.selectedItemAxis[0] = x;
			this.spreadsheetData.selectedItemAxis[1] = y;
		}
	}

	sortSpreadsheet(columnIndex?: number): void {
		if (columnIndex === undefined) {
			columnIndex = this.spreadsheetData.sort.sort_column;
		} else {
			if (this.spreadsheetData.sort.sort_column === columnIndex) {
				this.spreadsheetData.sort.sort_down = !this.spreadsheetData.sort.sort_down;
			} else {
				this.spreadsheetData.sort.sort_column = columnIndex;
				this.spreadsheetData.sort.sort_down = true;
			}
		}

		const header = this.spreadsheetData.lines[0].cells;

		this.spreadsheetData.lines = this.spreadsheetData.lines.sort((a, b) => {
			if (a.cells[0].item_name === '' || a.cells[0].item_name === null || a.cells[0].item_name === undefined) {
				return 0;
			}
			if (a.cells === header || b.cells === header) {
				return 1;
			}

			return this.spreadsheetData.sort.sort_down
				? a.cells[columnIndex].item_name.toString().localeCompare(b.cells[columnIndex].item_name, undefined, {
						numeric: true,
						sensitivity: 'base',
					})
				: b.cells[columnIndex].item_name.toString().localeCompare(a.cells[columnIndex].item_name, undefined, {
						numeric: true,
						sensitivity: 'base',
					});
		});
	}

	filterSpreadsheetColumn(): void {
		let temporarySpreadsheet: spreadsheetInterface = {
			...this.spreadsheetData,
			lines: [...this.spreadsheetData.lines],
			hiddenLines: [],
		};
		temporarySpreadsheet.lines = temporarySpreadsheet.lines.concat(temporarySpreadsheet.hiddenLines);
		temporarySpreadsheet.hiddenLines = [];
		temporarySpreadsheet = this.cleanBlanks(temporarySpreadsheet);
		let areFilterClean = true;
		for (let index = 0; index < this.spreadsheetData.lines[0].cells.length; index++) {
			if (
				this.spreadsheetData.lines[0].cells[index].header_cell &&
				this.spreadsheetData.lines[0].cells[index].header_cell.search_value &&
				this.spreadsheetData.lines[0].cells[index].header_cell.search_value.trim() !== ''
			) {
				areFilterClean = false;
				break;
			}
		}

		if (!areFilterClean) {
			for (let index = 0; index < this.spreadsheetData.lines[0].cells.length; index++) {
				if (
					this.spreadsheetData.lines[0].cells[index].header_cell &&
					this.spreadsheetData.lines[0].cells[index].header_cell.search_value &&
					this.spreadsheetData.lines[0].cells[index].header_cell.search_value.trim() !== ''
				) {
					for (let index_ = 1; index_ < temporarySpreadsheet.lines.length; index_++) {
						if (
							temporarySpreadsheet.lines[index_].cells[index].item_name !== '' &&
							!temporarySpreadsheet.lines[index_].cells[index].item_name
								.toString()
								.toLowerCase()
								.includes(this.spreadsheetData.lines[0].cells[index].header_cell.search_value.toLowerCase())
						) {
							temporarySpreadsheet.hiddenLines.push(temporarySpreadsheet.lines[index_]);
							temporarySpreadsheet.lines.splice(index_, 1);
							index_--;
						}
					}
				}
			}
		}

		temporarySpreadsheet = this.fulfillSpreadsheet(temporarySpreadsheet);
		this.spreadsheetData = temporarySpreadsheet;
		this.sortSpreadsheet();
	}

	exportExcel(): void {
		this.ExcelService.convertSpreadsheetToXLSX(this.spreadsheetData, this.spreadsheetData.title);
	}
}
